import { ref } from "vue";
import { defineStore } from "pinia";

export const useNotificationStore = defineStore("notification", () => {
  const unreadNotificationsCount = ref<number>(0);

  return {
    unreadNotificationsCount,
  };
});
